let globalOpenDrawer: (() => void) | null = null

export function setGlobalOpenDrawer(fn: () => void) {
  globalOpenDrawer = fn
}

export function openGlobalDrawer() {
  globalOpenDrawer?.()
}

export function clearGlobalOpenDrawer() {
  globalOpenDrawer = null
}